import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { CATEGORIES, sortedArticles } from "@/data/articles";
import { ArticleCard } from "@/components/ArticleCard";
import { BlogHeader } from "@/components/BlogHeader";
import { Footer } from "@/components/Footer";

export default function Riflessioni() {
    const [category, setCategory] = useState("Tutte");
    const articles = sortedArticles();
    const activeCategories = ["Tutte", ...CATEGORIES.slice(1).filter((c) => articles.some((a) => a.category === c))];
    const filtered = category === "Tutte" ? articles : articles.filter((a) => a.category === category);

    useEffect(() => {
        document.title = "Riflessioni — Blog di psicologia | Dott. Giovanni De Lorenzo";
        const meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute("content", "Riflessioni su emozioni, consapevolezza, ansia, relazioni e ipnosi. Articoli divulgativi del Dott. Giovanni De Lorenzo, psicologo e psicoterapeuta a Melfi.");
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-cream" data-testid="riflessioni-page">
            <BlogHeader />
            <main className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-16 md:py-24">
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
                    <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.25em] text-sage">Il blog</p>
                    <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-ink" data-testid="riflessioni-title">
                        Riflessioni
                    </h1>
                    <p className="mt-6 max-w-2xl text-base sm:text-lg text-[#526063] leading-relaxed">
                        Pensieri e approfondimenti su psicologia, emozioni e consapevolezza: per guardare ciò che viviamo con parole più chiare.
                    </p>
                </motion.div>

                <div className="mt-10 flex flex-wrap gap-3" data-testid="riflessioni-filters" role="group" aria-label="Filtra per categoria">
                    {activeCategories.map((c) => (
                        <button
                            key={c}
                            data-testid={`filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            onClick={() => setCategory(c)}
                            aria-pressed={category === c}
                            className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-all duration-300 ${
                                category === c
                                    ? "bg-petrol text-cream shadow-md"
                                    : "border border-ink/15 text-ink/70 hover:border-petrol hover:text-petrol"
                            }`}
                        >
                            {c}
                        </button>
                    ))}
                </div>

                {filtered.length > 0 ? (
                    <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-testid="riflessioni-grid">
                        {filtered.map((a, i) => (
                            <motion.div
                                key={a.slug}
                                initial={{ opacity: 0, y: 24 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: i * 0.08 }}
                            >
                                <ArticleCard article={a} testid={`article-card-${a.slug}`} />
                            </motion.div>
                        ))}
                    </div>
                ) : (
                    <p className="mt-12 text-center text-[#7A8C8E] italic" data-testid="riflessioni-empty">
                        Nessun articolo in questa categoria per ora: stiamo preparando nuove riflessioni.
                    </p>
                )}
            </main>
            <Footer />
        </div>
    );
}
